import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export function ConfirmModal({
  show,
  onCancel,
  onConfirm,
  title = 'Confirm',
  body,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'danger',
  confirmTestId,
}) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {typeof body === 'string' ? <p className="mb-0">{body}</p> : body}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm} data-testid={confirmTestId}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}


